<template>
  <!-- 会议 -->
  <div class="module-layout">
    <BlockFrame :header="{title:$tx('hygl.hyyt.meetingLation','会议室预定'),icon:appletData.icon,more:false,code:'nonExecution'}">
      <img :src="url" class="bg">
      <!-- 已绑定工位 -->
      <div class="meet-content">
        <div class="flex">
          <div class="typeface" style="display: flex;align-items: center;justify-content: space-between;width:100%;">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="pter">
                <svg-icon icon-class="build" style="width: 12px; height: 12px;margin-right:5px" /><span style="padding: 0 3px 0 12px;">{{ cityName }}</span>
              <!-- <svg-icon icon-class="shaixuan" style="width: 12px; height: 12px;" /> -->
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in floorOptions" :key="item.id" :command="item">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div style="cursor: pointer;">{{ $tx('hygl.hyyt.enterReservation','进入预定') }} > </div>
          </div>
        </div>
        <div>
          <el-slider
            v-model="value1"
            :show-tooltip="false"
            :format-tooltip="formatTooltip"
            @input="sliderChange"
          />
          <div id="scroll" class="scroll" :style="{'height':scrollH}">
            <div style="margin: 0 5px;">
              <div v-for="(item,index) in listData" :key="index" class="content">
                <div style="display: flex;justify-content: space-between;padding-bottom: 5px;">
                  <span class="typeface">{{ item.name }}</span>
                  <div style="display: flex;align-items: flex-end;margin-right: 5px;">
                    <span v-text-lbl="'hygl.portlet.personUnit'" class="typeface" style="font-size:10px;color:#ABABAB;" :num="item.numPeople"> {{ item.numPeople }}人</span>
                  </div>
                </div>
                <div style="width:100%;height:45px;overflow:hidden;position: relative;">
                  <div style="height:21px;display:flex;justify-content: flex-start;" class="scroll-time">
                    <div v-for="it in meetRoom" :key="it.name" style="position: relative;" class="meetRoom1">
                      <el-popconfirm
                        v-if="(Number(nowHoer)-Number(it.name)) <= 0"
                        :key="it.name+item.id+'p'"
                        :ref="it.name+item.id+'pp'"
                        popper-class="pro-titleA1"
                        class="popconfirm11"
                        hide-icon="true"
                        :title="$tx('hygl.portlet.isQuickMeeting','是否快速预定该会议室？')"
                        :confirm-button-text="$tx('hygl.portlet.quickBooking','快速预定')"
                        @confirm="openMeet(item)"
                        @onConfirm="openMeet(item)"
                        @cancel="cancelClick(it.name+item.id+'pp')"
                      >
                        <div v-if="it.name== nowTime.day && nowTime.mit<45" :id="it.name+item.id" slot="reference" :ref="it.name+item.id" v-clickoutside="clickoutside" style="background: #fff" class="meet-box1 resize" :style="{'width':bigScreen?'41.8px':'33.1px'}" @mousedown="onmousedown($event,it.name+item.id,it.name,item,nowTime.mit*contentWidth/60)" />
                        <div v-else :id="it.name+item.id" slot="reference" :ref="it.name+item.id" v-clickoutside="clickoutside" style="background: #fff" class="meet-box1 resize" :style="{'width':bigScreen?'41.8px':'33.1px'}" @mousedown="onmousedown($event,it.name+item.id,it.name,item,0)" />
                      </el-popconfirm>
                      <el-tooltip v-else transition="" :open-delay="300" class="item" :content="$tx('hygl.portlet.toolTip','不可预订已过时间的会议室')" effect="dark" placement="top">
                        <div :id="it.name+item.id" class="meet-box1 roomCls1" style="position:relative; cursor: not-allowed;" :style="{'width':contentWidth+'px'}" />
                      </el-tooltip>
                      <el-tooltip v-if="it.name== nowTime.day && nowTime.mit<45" transition="" :open-delay="300" class="item" :content="$tx('hygl.portlet.toolTip','不可预订已过时间的会议室')" effect="dark" placement="top">
                        <div :id="it.name+item.id" class="meet-box1 po-r roomCls1" style="position:relative;cursor: not-allowed;" :style="{'width':(nowTime.mit*contentWidth/60)+'px',top:'-21px'}" />
                      </el-tooltip>
                      <div v-if="it.name== nowTime.day && nowTime.mit<45" class="typeface timeStamp" style="margin-top: -16px;">{{ it.num }}</div>
                      <div v-else class="typeface timeStamp">{{ it.num }}</div>
                      <div v-for="(itSchedule) in item.meetingList" :key="itSchedule.beginTime" class="roomDv">
                        <el-tooltip v-if="(Number(nowHoer)-Number(itSchedule.eTime)) > 0&&it.name == itSchedule.sTime" transition="" :open-delay="300" class="item" :content="$tx('hygl.portlet.toolTip2','过去时段被预订')" effect="dark" placement="top">
                          <div class="roomCls" :style="{width: itSchedule.vTime*contentWidth+'px',background: '#ECECEC'}" />
                        </el-tooltip>
                        <el-tooltip v-else-if="it.name == itSchedule.sTime&&itSchedule.sMinute>=15" transition="" :open-delay="300" class="item" :content="$tx('hygl.portlet.toolTip3','当前时段已被预订')" effect="dark" placement="top">
                          <div class="roomCls" :style="{width: (itSchedule.vTime*contentWidth)+'px',marginLeft: (itSchedule.sMinute*contentWidth/60)+'px',backgroundColor: '#FFF1E4',borderLeft: '2px solid #FF6A00',borderRadius: '2px 0px 0px 2px'}" />
                        </el-tooltip>
                        <el-tooltip v-else-if="it.name == itSchedule.sTime" transition="" :open-delay="300" class="item" :content="$tx('hygl.portlet.toolTip3','当前时段已被预订')" effect="dark" placement="top">
                          <div class="roomCls" :style="{width: itSchedule.vTime*contentWidth+'px',marginLeft: '0px',backgroundColor: '#FFF1E4',borderLeft: '2px solid #FF6A00',borderRadius: '2px 0px 0px 2px'}" />
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="meetingSelect==='recommend'&&listData.length==0" class="block">
          <div class="typeface tip">
            <div v-text-lbl="'hygl.portlet.isNullMeeting'" style="font-size: var(--portalFontSize14);margin-bottom: 15px;"> 暂时没有空闲会议室哦 </div>
          <!-- <div style="font-size: var(--portalFontSize14);margin-bottom: 15px;">请前往<span style="color:#FF6A00;" class="pter" @click="goUrl('wxwork://message?username=')">「企微」</span>会议室进行检索</div> -->
          </div>
        </div>
        <div v-if="meetingSelect==='recommendSearch'&&listData.length==0" class="block">
          <div class="typeface tip">
            <div v-text-lbl="'hygl.portlet.isRowsNullMeeting'" style="font-size: var(--portalFontSize14);margin-bottom: 15px;">您选择的楼层暂时没有空闲会议室哦 </div>
            <div v-text-lbl="'hygl.portlet.selectOtherFloor'" style="font-size: var(--portalFontSize14);margin-bottom: 15px;"> 请选择其他楼层进行检索 </div>
          </div>
        </div>
      </div>
      <MeettingDialog :title="meetTitle" />
    </BlockFrame>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MeettingDialog from './MeettingDialog'
const moment = require('moment')
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
        MeettingDialog
    },
    props: {
        appletData: { type: Object, default: function() { return {} } },
        name: { type: String, default: '' },
        id: { type: String, default: '' },
        searchType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            nowTime: {
                day: 0,
                mit: 0
            },
            url: '../imgs/meet_bg.png',
            value1: 54,
            startTime: '',
            endTime: '',
            edificeName: '',
            cityName: '',
            floorName: '',
            stationNum: '',
            showFlag: '',
            meetTitle: this.$tx('hygl.hyyt.meetingLation', '会议室预定'),
            showDialog: false,

            workStation: {},
            meetRoom: [{ num: 0, name: '00' }, { num: 1, name: '01' }, { num: 2, name: '02' }, { num: 3, name: '03' }, { num: 4, name: '04' }, {
                num: 5, name: '05' }, { num: 6, name: '06' }, { num: 7, name: '07' }, { num: 8, name: '08' }, { num: 9, name: '09' }, {
                num: 10, name: '10' }, { num: 11, name: '11' }, { num: 12, name: '12' }, { num: 13, name: '13' }, { num: 14, name: '14' }, {
                num: 15, name: '15' }, { num: 16, name: '16' }, { num: 17, name: '17' }, { num: 18, name: '18' }, { num: 19, name: '19' }, {
                num: 20, name: '20' }, { num: 21, name: '21' }, { num: 22, name: '22' }, { num: 23, name: '23' }
            ],
            nowHoer: 0,
            contentWidth: 0,
            clientWidth: document.body.clientWidth,
            minTime: '', // 可预订的最小时间
            maxTime: '', // 可预订的最大时间
            selectStartTime: '', // 选择的开始时间
            selectEndTime: '', // 选择的结束时间,
            meetingSelect: 'recommend',
            meetingSelectOld: '',
            visible: false,
            activeFloor: null, // 筛选楼层
            floorOptions: null,
            scrollH: '',
            allData: [], // 全部数据
            listData: [], // 显示数据
            isHave: true, // 是否还有下一页
            active: 1 // 当前页
        }
    },
    computed: {
        ...mapGetters(['routes'])
    },
    // 监控data中的数据变化
    watch: {
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$options.components['BlockFrame'] = this.$loadComponent('@/wapp/common/components/BlockFrame/index')
        const hour = new Date().getHours()
        this.nowTime = {
            mit: moment(new Date()).format('mm'),
            day: moment(new Date()).format('HH')
        }
        if (hour > 16) this.value1 = 100
        this.getfloor()
        // this.getMeetData('first')
        this.$bus.on('getMeetData', this.getMeetData)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // this.dragControllerDiv()
        this.getWindowInfo()
        window.addEventListener('resize', this.getWindowInfo)
        this.cancelClick()
        document.addEventListener('click', (e) => {
            var thisClassName = e.target.className
            if (thisClassName) {
                if (!thisClassName.includes('el-popover')) {
                    this.cancelClick()
                }
            }
        })
        this.clientWidth = document.body.clientWidth
        this.$nextTick(() => {
            const dom = document.getElementById('scroll')
            dom.addEventListener('scroll', this.scrollHeight)
        })
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowInfo)
        this.$bus.off('getMeetData', this.getMeetData)
    }, // 生命周期 - 销毁之前
    destroyed() {
        // document.removeEventListener('mouseup', this.mouseUp)

    }, // 生命周期 - 销毁完成
    activated() {},
    // 方法集合
    methods: {
        scrollHeight(e) {
            $('.el-popper ').css({ 'display': 'none' })
            $('.pro-titleA1').css({ 'display': 'none' })
            const scrollTop = e.target.scrollTop
            const clientHeight = e.target.clientHeight
            const scrollHeight = e.target.scrollHeight

            if ((scrollTop + clientHeight + 5) >= scrollHeight) {
                if (this.isHave) {
                    this.active++
                    const list = JSON.parse(JSON.stringify(this.allData))
                    this.listData = list.splice(0, this.active * 4)
                    if (this.listData.length >= this.allData.length) this.isHave = false
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.sliderChange(this.value1, 1)
                        }, 50)
                    })
                }
            }
        },
        handleCommand(command) {
            console.log('command', command)
            this.meetingSelectOld = this.meetingSelect
            this.meetingSelect = command
            this.cityName = command.name
            this.active = 1
            this.isHave = true
            if (this.meetingSelect === 'recommendSearch') {
                if (!this.floorOptions) this.getfloor()
                this.visible = true
                return
            }
            this.activeFloor = ''
            this.getMeetData(command.id)
        },
        getfloor() {
            this.$http({
                method: 'POST',
                // url: '/portal/workStation/getMansionFloor'
                url: 'hygl/site/querydata',
                data: [{
                    'compare': '=',
                    'field': 'status',
                    'merge': true,
                    'value': 1
                }, {
                    'compare': '=',
                    'field': 'orgCode',
                    'merge': true,
                    'value': this.loginUser.orgCode
                }],
                params: { 'orderBy': 'orderNo asc' }
            }).then(res => {
                if (res.code === 'success') {
                    // res.body.result.forEach(item => {
                    //     if (item.cityName === this.cityName) {
                    //         item.children.forEach(child => {
                    //             if (child.edificeName === this.edificeName) {
                    //                 this.floorOptions = child.children
                    //             }
                    //         })
                    //     }
                    // })
                    this.cityName = res.body.listdata[0].name
                    this.cityId = res.body.listdata[0].id
                    this.floorOptions = res.body.listdata
                    this.getMeetData('first')
                }
            })
        },
        getWindowInfo() {
            this.clientWidth = document.body.clientWidth
            if (document.body.clientWidth > 1600) {
                this.bigScreen = true
                this.appletData.h = this.appletData.rowSpan - 3
                this.scrollH = '213px'
                this.contentWidth = 41.8
            } else {
                this.bigScreen = false
                this.appletData.h = this.appletData.rowSpan
                this.scrollH = '270px'
                this.contentWidth = 33.5
            }
            this.$nextTick(() => {
                this.sliderChange(this.value1)
            })
        },
        formatTooltip(val) {
            if (val >= 75 && val <= 100) {
                return '晚上'
            } else if (val >= 0 && val < 50) {
                return '早上'
            } else if (val >= 50 && val < 75) {
                return '中午'
            }
        },
        goUrl(url) {
            location.href = url
        },
        onmousedown(e, val, hover, item, width) {
            const childW = this.contentWidth
            this.cancelClick()
            var maxLength = childW
            const _this = this
            var aaa = document.getElementById(val)
            aaa.innerHTML = `
              <div  style="position: absolute;top: 0;left: ${width}px;width:calc(100% - ${width}px) ;height: 98%;background: rgba(88, 176, 86, 0.5);z-index: 9;">
                <img src="../imgs/dragRight.png" style="position: absolute;top: 50%;right:-5px;width: 5.95px;height: 10.53px;transform: translateY(-50%);">
              <div>
            `
            const hours = moment(new Date()).format('HH')
            const mintes = moment(new Date()).format('mm')
            // 如果今天没有别的会议安排
            if (!item.schedule || item.schedule.length === 0) {
                if (Number(mintes) < 15) {
                    this.minTime = hours + ':15'
                } else if (Number(mintes) < 30) {
                    this.minTime = hours + ':30'
                } else if (Number(mintes) < 45) {
                    this.minTime = hours + ':45'
                } else {
                    this.minTime = (Number(hours) + 1) + ':00'
                }
                this.selectStartTime = Number(hover) > Number(hours) ? hover + ':00' : this.minTime
                this.maxTime = '24:00'
                this.selectEndTime = (Number(this.selectStartTime.split(':')[0]) + 1) + ':00' // + this.selectStartTime.split(':')[1]
                // console.log(0, this.selectEndTime)
            } else {
                const min = []
                const max = []
                for (var i = 0; i < item.schedule.length; i++) {
                    // console.log(Number(item.schedule[i].sTime), Number(hover))
                    if (Number(item.schedule[i].sTime) > Number(hover) || (Number(item.schedule[i].sTime) == Number(hover) && Number(item.schedule[i].sMinute) >= 15)) {
                        max.push({ hh: Number(item.schedule[i].sTime), mm: Number(item.schedule[i].sMinute) })
                    } else if (Number(item.schedule[i].eTime) <= Number(hover) && (Number(item.schedule[i].eTime) > Number(hours) || (Number(item.schedule[i].eTime) === Number(hours) && Number(item.schedule[i].eMinute) > Number(mintes)))) {
                        min.push({ hh: Number(item.schedule[i].eTime), mm: Number(item.schedule[i].eMinute) })
                    }
                }
                if (min.length === 0) {
                    if (Number(mintes) < 15) {
                        this.minTime = hours + ':15'
                    } else if (Number(mintes) < 30) {
                        this.minTime = hours + ':30'
                    } else if (Number(mintes) < 45) {
                        this.minTime = hours + ':45'
                    } else {
                        this.minTime = (Number(hours) + 1) + ':00'
                    }
                    this.selectStartTime = Number(hover) > Number(hours) ? hover + ':00' : this.minTime
                } else {
                    let hh = min[0].hh
                    let mm = min[0].mm
                    min.forEach(item => {
                        if (item.hh > hh || (item.hh == hh && item.mm > mm)) {
                            hh = item.hh
                            mm = item.mm
                        }
                    })
                    // if (mm == 45) {
                    //     this.minTime = (Number(hh) + 1) + ':00'
                    // } else {
                    this.minTime = hh + ':' + (mm == 0 ? '00' : mm)
                    //     this.minTime = hh + ':' + (mm + 15)
                    // }
                    this.selectStartTime = Number(this.minTime.split(':')[0]) < Number(hover) ? hover + ':00' : this.minTime
                }
                console.log(max, 'max')
                if (max.length === 0) {
                    this.maxTime = '24:00'
                    this.selectEndTime = (Number(this.selectStartTime.split(':')[0]) + 1) + ':00' // + this.selectStartTime.split(':')[1]
                } else {
                    let hh = max[0].hh
                    let mm = max[0].mm
                    max.forEach(item => {
                        if (item.hh < hh || (item.hh == hh && item.mm < mm)) {
                            hh = item.hh
                            mm = item.mm
                        }
                    })
                    this.maxTime = hh + ':' + (mm == 0 ? '00' : mm)
                    this.selectEndTime = (Number(this.selectStartTime.split(':')[0]) + 1) + ':00' // + this.selectStartTime.split(':')[1]
                    // console.log('max1', this.selectEndTime)
                    if (Number(this.selectEndTime.split(':')[0]) > Number(this.maxTime.split(':')[0]) || (Number(this.selectEndTime.split(':')[0]) === Number(this.maxTime.split(':')[0]) && Number(this.selectEndTime.split(':')[1]) > Number(this.maxTime.split(':')[1]))) {
                        this.selectEndTime = this.maxTime
                        // console.log('max2', this.selectEndTime)
                    }
                }
            }
            var startX = e.clientX
            var endDay = ''
            e.target.left = e.target.offsetLeft
            maxLength = (Number(this.maxTime.substring(0, 2)) - (Number(hover))) * childW
            document.onmousemove = function(e) {
                var endX = e.clientX
                // var a = Number(e.target.style.width.substring(0, e.target.style.width.length - 2))
                var moveLen = childW + (endX - startX) // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
                // var moveLen = a + (endX - startX)
                if (moveLen < childW) moveLen = childW // 左边区域的最小宽度为40px
                if (moveLen > maxLength) moveLen = maxLength
                aaa.children[0].style.width = moveLen + 'px' // 设置宽度
                const count = moveLen % childW
                if (count === 0) {
                    endDay = Math.floor(moveLen / childW) + Number(hover)
                    endDay = endDay + ':00'
                } else if (count < (childW / 4)) {
                    endDay = Math.floor(moveLen / childW) + Number(hover)
                    endDay = endDay + ':15'
                } else if (count < (childW / 2)) {
                    endDay = Math.floor(moveLen / childW) + Number(hover)
                    endDay = endDay + ':30'
                } else if (count < (childW / 4 * 3)) {
                    endDay = Math.floor(moveLen / childW) + Number(hover)
                    endDay = endDay + ':45'
                } else {
                    endDay = Math.floor(moveLen / childW) + Number(hover) + 1
                    endDay = endDay + ':00'
                }
                // if (count != 0) {
                _this.selectEndTime = endDay
                // }
                // console.log('move', _this.selectEndTime, count)
                if (Number(_this.selectEndTime.split(':')[0]) > Number(_this.maxTime.split(':')[0]) || (Number(_this.selectEndTime.split(':')[0]) === Number(_this.maxTime.split(':')[0]) && Number(_this.selectEndTime.split(':')[1]) > Number(_this.maxTime.split(':')[1]))) {
                    _this.selectEndTime = _this.maxTime
                }
                if (moveLen > maxLength) {
                    moveLen = maxLength
                    return
                }
            }
            // 鼠标放开
            document.onmouseup = function(evt) {
                document.onmousemove = null
                document.onmouseup = null
                e.target.releaseCapture && e.target.releaseCapture() // 当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
                // }
                //
                e.target.setCapture && e.target.setCapture() // 该函数在属于当前线程的指定窗口里设置鼠标捕获
                // return false
            }
        },
        openMeet(item) {
            // console.log(this.minTime, 'this.minTime')
            const time = this.minTime.split(':')
            if (Number(time[1]) > 0) {
                time[1] = Number(time[1]) - 15
                if (time[1] == 0) time[1] = '00'
            } else {
                time[0] = Number(time[0]) - 1
                time[1] = 45
                if (time[0] < 10) time[0] = '0' + time[0].toString()
            }
            this.minTime = time.join(':')
            // console.log(this.minTime, 'this.minTime')
            this.$bus.emit('openMeetDialog', this.minTime, this.maxTime, this.selectStartTime, this.selectEndTime, item, this.cityName, true)
        },
        getStatusUrl() {
            this.$http({
                method: 'get',
                contentType: 'application/x-www-form-urlencoded',
                url: '/portal/workStation/getWorkStationBinDingUrl?empNo=' + this.loginUser.employeeNo + '&redirectUrl=' + location.href
            }).then(async res => {
                if (res.code === 'success') {
                    window.open(res.body.result, '_blank')
                } else {
                    this.loginOutMain(res.body.result)
                    // this.$message.error(res.message)
                }
            })
        },
        searchSubmit() {
            if (this.activeFloor) {
                this.getMeetData()
                this.visible = false
            } else {
                this.$message.error(this.$tx('hygl.message.selectFloor', '请选择筛选楼层'))
            }
        },
        getMeetData(val) {
            this.nowHoer = Number(moment(new Date()).format('mm')) >= 45 ? Number(moment(new Date()).format('HH')) + 1 : Number(moment(new Date()).format('HH'))
            const params = {
                allMeetingRoom: this.meetingSelect === 'all',
                startDate: moment().startOf('days').format('YYYY-MM-DD'),
                endDate: moment().endOf('days').format('YYYY-MM-DD')
                // startDate: '2023-05-24',
                // endDate: '2023-05-24'
            }
            if (val && val !== 'first') {
                params.siteId = val
                console.log('11')
            } else {
                console.log('222')
                params.siteId = this.cityId
            }
            if (this.meetingSelect === 'recommendSearch' && this.activeFloor) {
                params.cityName = this.cityName
                params.building = this.edificeName
                params.floor = this.activeFloor.replace('F', '').replace('f', '')
            }

            this.$http({
                method: 'GET',
                url: '/hygl/meeting/queryMeetingRoomReserveInfo',
                // url: '/portal/zeekrMeeting/getMeetingRoomInfo',
                params: params
            }).then(res => {
                // if (JSON.stringify(res.body.workStation) !== '{}') {
                //     this.edificeName = res.body.workStation.edificeName
                //     this.cityName = res.body.workStation.cityName
                //     this.floorName = res.body.workStation.floorName
                //     this.showFlag = res.body.workStation.showFlag
                //     this.stationNum = res.body.workStation.stationNum
                //     this.workStation = res.body.workStation
                // }
                this.allData = res.body.listdata || []
                if (this.allData.length > 0) {
                    this.allData.forEach(item => {
                        item.meetingList = []
                        if (item.weekdays.length > 0) {
                            item.weekdays.forEach(it => {
                                // item.meetingList.push(it.meetingList)
                                it.meetingList.forEach(i => {
                                    // i.vTime = parseFloat(Math.floor((new Date(i.endTime) - new Date(i.beginTime)) / (60 * 1000)) / 60)
                                    // i.sTime = moment(i.beginTime).format('HH')
                                    // i.eTime = Number(moment(i.endTime).format('HH'))
                                    // i.sMinute = Number(moment(i.beginTime).format('mm'))
                                    // i.eMinute = Number(moment(i.endTime).format('mm'))
                                    item.meetingList.push(i)
                                })
                            })
                        }
                    })
                    this.allData.forEach(item => {
                        item.meetingList.forEach(it => {
                            it.vTime = parseFloat(Math.floor((new Date(it.endTime) - new Date(it.beginTime)) / (60 * 1000)) / 60)
                            it.sTime = moment(it.beginTime).format('HH')
                            it.eTime = Number(moment(it.endTime).format('HH'))
                            it.sMinute = Number(moment(it.beginTime).format('mm'))
                            it.eMinute = Number(moment(it.endTime).format('mm'))
                            console.log('itititit', it)
                        })
                    })
                    const list = JSON.parse(JSON.stringify(this.allData))
                    this.listData = list.splice(0, this.active * 4)
                    console.log('listData', this.listData)
                    if (val === 'first') {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.sliderChange(this.value1)
                            }, 500)
                        })
                    }
                }
            })
        },
        sliderChange(val, type) {
            this.value1 = val
            if (this.contentWidth === 41.8) {
                $('.scroll-time').stop().animate({ 'right': `-${(100 - val) / 100 * 115.5}%` }, type ? 0 : 1000, 'linear', function() { })
            } else {
                $('.scroll-time').stop().animate({ 'right': `-${(100 - val) / 100 * 95}%` }, type ? 0 : 1000, 'linear', function() { })
            }
        },
        clickoutside() {
        },
        cancelClick(val) {
            $('.resize').empty()
        }

    } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss">
.recommendSearch{
  padding: 20px;
  // margin-left: -85px;
  margin-top: 5px !important;
  border-radius: 12px !important;
  .el-button{
    height: 36px;
    width: 80px;
    text-align: center;
    margin-right: 25px;
  }
}
.pro-titleA1{
  border-radius: 12px !important;
  .el-popconfirm__main{
    color: #000;
    font-size: 18px;
    margin-bottom: 25px;
  }
  .el-popconfirm__action{
    padding: 0 10px;
  }
  .el-button{
    height: 36px;
  }
  .el-button--text{
    color: #000;
    width: 80px;
    margin-right: 25px;
    border-radius: 8px;
    background: #f5f5f6;
    text-align: center;
    // line-height: 36px;
  }
}
</style>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.tipcolo{
  color: var(--bgColor);
}
.module-layout {
  width: 100%;
  // width: 408px;
  height: 100%;
  border:1px solid #E4E7ED;
  background-color: #f0f2f8;
  position: absolute;
  z-index: 1;
}
.other-component{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    background: linear-gradient(134.33deg, #FFFFFC -6.12%, #F4F5FF 32.85%, #F0F3FF 87.96%);
    opacity: 0.8;
    border-radius: 8px;
    border: 1px solid #FFFFFF;
    margin-bottom: 4px;
}
a:hover{
    color: var(--bgColor) !important;
}
.typeface{
    font-style: normal;
    font-weight: 400;
    font-size: var(--portalFontSize12);
}
.flex{
    display:flex;
    justify-content: space-between;
}
  .bg{
      width:100%;
      height:100%;
      position: absolute;
      z-index: -1;
  }
  .meet-content{
      margin: 30px 20px 0;
  }
  .block{
      margin-top: 10px;
  }
  .content{
      margin-top:8px;
  }
  .scroll{
    // overflow-y: scroll;
    // height: 250px;
    // min-width: 480px;
    overflow-x: hidden;
  }
  .scroll::-webkit-scrollbar {
        width: 5px;
        background-color: #f1f1f1;
    }

    .scroll::-webkit-scrollbar-track {
        background-color: #f1f1f1;
    }

    .scroll::-webkit-scrollbar-thumb {
      opacity: 0.5;
        background: rgba(144,147,153,0.3);
        border-radius: 4px;
    }
    .scroll-time {
      position: absolute;
      top: 0;
      // left: 0;
    }

  .tip{
      display: flex;
      height: 341px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: var(--portalFontSize14);
      color: rgba(0, 0, 0, 0.75);
  }
  .bind{
      width: 112px;
      height: 36px;
      background: #FFFFFF;
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.04);
      border-radius: 12px;
      font-size: var(--portalFontSize14);
      text-align: center;
      color: #FF6A00;
      margin-bottom: 12px;
  }
  .foot{
      position: absolute;
      bottom: 20px;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: center;
  }
  .foot-left{
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0));
    height: 1px;
    width: 12px;
    margin-top: 6px;
    margin-right: 10px;
  }
  .foot-right{
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0));
    height: 1px;
    width: 12px;
    margin-top: 6px;
    margin-left: 10px;
  }
  .resiz {
    position: relative;
  }
  .resizeC {
    position: absolute;

    // top:0;
    // left: 0;
    // position: relative;
    z-index: 666;
  }

  .meetRoom1:nth-child(n+11) {
    .timeStamp {
        margin-left: -9.5px;
    }
  }
  .meetRoom1:nth-child(25) {
    .timeStamp {
        margin-left: -12px;
    }
  }
  .meetRoom1:nth-child(25) {
    .timeStamp {
        margin-left: -12px;
    }
    background-color: #fff;
  }

  .meet-box1{
      // width: 41.8px;
      height:100%;
      border:0.5px solid #DADADA;
      background: #F7F7F7;
      border-right: none;
      border-radius: 0px;
      cursor:pointer;
  }
  .meet-box2{
      width: 40px !important;
      height:100%;
      background: #FFF1E4;
      border: 0.5px solid #DADADA;
      border-left: 2px solid #FF6A00;
      border-radius: 2px 0px 0px 2px;
  }
  .meet-box3{
      width: 40px !important;
      height:100%;
      background: #FFF1E4;
      border-radius: 0px;
      border: 0.5px solid #DADADA;
  }
  .timeStamp{
      margin-top:5px;
      color: #ABABAB;
  }
  .roomDv {
    position: absolute;
    top: 3px;
    left: 0;
    // background-color: #ccc;
    height: 100%;
    .roomCls {
      position: absolute;
      top: -3px;
      left: 0;
      height: 100%;
      opacity: 0.9;
      z-index: 100;
    }
  }
  /deep/.el-slider__bar{
      background: #F76400;
  }
  /deep/.el-slider__button{
      width: 11px;
      height: 11px;
      border: 1px solid #F76400;
  }
  /deep/.el-slider__runway{
      background: #fad7c2;
  }
  /deep/.el-slider__button-wrapper{
      background: rgba(247, 100, 0, 0.15) !important;
      border: 0.588235px solid #F76400;
      border-radius: 100%;
      height: 30px;
      width: 30px;
      top: -13px;
  }
  /deep/.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
    background: #FFF1E4 !important;
    cursor: auto;
  }
</style>

